var path = 'areas/projects/actions/certificate_import/Octopus.Certificate.Import_summary.html';
var html = "<p> Import Certificate from variable <strong>{{properties[\"Octopus.Action.Certificate.VariableName\"]}}</strong> into Windows Certificate Store <strong>{{properties[\"Octopus.Action.Certificate.CertStorePath\"]}}</strong> <span ng-show=isSingleStep>on machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/certificate_import/Octopus.Certificate.Import_summary.html
// module id = 33775393801014
// module chunks = 1